import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';
import numeral from 'numeral';
import {
  Segment,
  Message,
  MessageHeader,
  MessageContent,
  Button,
  Input,
  Icon,
  Divider,
  Table,
  Label,
  Card,
} from 'semantic-ui-react';
import { CSVLink } from 'react-csv';
import _ from 'lodash';
import { loadingDiscussions, reloadDiscussions } from './actions';

import InfluencerGroup from '../../components/influencer-group';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';
import hasLocalStorageClient from '../../hocs/has-localstorage-client';

import { getInfluencerFromOrganisations } from '../../utils/helper-functions';
import NewInfluencerTabModal from '../../components/new-influencer-tab-modal';
import CampaignLiveStatus from '../../components/campaign-live-status';
import CsvUploadModal from '../../components/csv-upload-modal';
import CsvUploadStatusModal from '../../components/csv-upload-modal/status-modal';


const RESTRICTED_CORQ_DOMAINS = [
  'data.corq.studio',
  'corq.dyzio.co',
];

let mountStart;

const listStyle = {
  paddingTop: 20,
  padding: '0px 30px',
};

const INVITATION_STATUS = {
  deferred: 'DEFERRED',
  sent: 'SENT',
  accepted: 'ACCEPTED',
};

const FILTER_TYPES = {
  posted: 'posted',
  not_posted: 'not_posted',
  errors: 'errors',
};

const buttonsStyles = {
  container: {
    display: 'flex',
  },
};


class DiscussionList extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor() {
    super();
    this.state = {
      filterTerm: '',
      filterType: null,
      isModalDismissed: false,
      showUploadModal: false,
      showUploadStatusModal: false,
      isImporting: false,
    };
  }

  componentWillMount = () => {
    mountStart = moment();
  }

  componentDidMount = () => {
    const mountFinish = moment();
    const diff = mountFinish.diff(mountStart);
  }

  onFilterDiscussionListByTermChanged = _.debounce((event, data) => {
    const { value: filterTerm } = data;
    this.setState({
      filterTerm,
    });
  }, 800);

  onFilterTypeChanged = (e, v) => {
    console.log(`filtering to ${v.value}`);
    const { filterType } = this.state;
    if (filterType === v.value) {
      e.target.blur();
      return this.setState({
        filterType: null,
      });
    }
    return this.setState({
      filterType: v.value,
    });
  }

  getInvitationStatus = ({ discussion }) => {
    if (!discussion.invitations) return INVITATION_STATUS.deferred;
    const invite = discussion.invitations[0];
    const influencerJoined = (invite === undefined);
    const derivedSent = invite ? ((invite.status === INVITATION_STATUS.sent)) : false;

    if (influencerJoined) {
      return INVITATION_STATUS.accepted;
    }

    if (derivedSent) {
      return INVITATION_STATUS.sent;
    }

    return INVITATION_STATUS.deferred;
  };

  isSearchMatch = ({ discussion, influencer, searchTerm }) => {
    if (!influencer) return true;
    const { primarySocialHandle, name } = influencer;
    const hasSearchTerm = searchTerm && _.size(searchTerm) > 0;
    if (!hasSearchTerm) return true;
    const discussionName = discussion && discussion.name ? discussion.name : '';

    const term = _.trim(searchTerm);
    const regEx = new RegExp(term, 'i');

    const matchesByName = discussionName.match(regEx);
    const matchesByInfluencerName = name.match(regEx);
    const matchesByPrimaryHandle = primarySocialHandle.match(regEx);

    if (hasSearchTerm && !matchesByName && !matchesByPrimaryHandle && !matchesByInfluencerName) {
      return false;
    }

    return true;
  }

  getTotalAssetCount = ({ discussion }) => {
    const assets = _.compact(discussion.trackedAssets);
    const stories = _.compact(discussion.stories);

    const count = _.get(stories, 'length', 0) + _.get(assets, 'length', 0);
    return count;
  }

  dismissModal = () => {
    this.setState({
      isModalDismissed: true,
    });
  }

  dontShowAgain = () => {
    const {
      dyzioStorage,
    } = this.props;
    dyzioStorage.set(dyzioStorage.KEYS.SHOW_NEW_INFLUENCER_TAB_MODAL, false);
    this.setState({
      isModalDismissed: true,
    });
  }

  shouldShowModal = () => {
    const {
      dyzioStorage,
    } = this.props;
    return false;
    const { isModalDismissed } = this.state;
    const { origin } = window.location;
    if (!origin.match(/dyzio/)) {
      console.log(`not showing modal on ${origin}`);
      return false;
    }
    const storageValue = dyzioStorage.get(dyzioStorage.KEYS.SHOW_NEW_INFLUENCER_TAB_MODAL);
    if (storageValue === false) return false;
    if (isModalDismissed) return false;
    return true;
  }

  toggleUploadModal = () => {
    this.setState(prev => ({ showUploadModal: !prev.showUploadModal }));
  }

  toggleUploadStatusModal = () => {
    this.setState(prev => ({ showUploadStatusModal: !prev.showUploadStatusModal }));
  }


  buildCSVData = discussions => {
    const discussionFields = [
      'createdDate',
      'name',
      'internalDiscountCode',
      'bioLinkUrl',
      'shortDiscountLink',
      'workflowStatus',
      'hasPosted',
    ];

    const influencerFields = [
      'instagram',
      'tiktok',
      'email',
      'instagramId',
      'instagramCount',
      'tiktokId',
      'tiktokCount',
      'usageRightsGranted',
      'discountCode',
    ];

    const flatDiscussions = _.map(discussions, d => {
      const flat = _.pick(d, discussionFields);

      let influencer = d.influencer;

      if (!influencer) {
        const influencerOrgs = _.filter(d.organisations, { orgType: 'INFLUENCER' });
        const influencerOrg = _.head(influencerOrgs);
        influencer = _.get(influencerOrg, 'influencer');
      }

      if (influencer) {
        const influencerLight = _.pick(influencer, influencerFields);
        _.assignIn(flat, influencerLight);
      }

      return flat;
    });

    return flatDiscussions;
  };

  getCSVFileName = campaignName => `${_.kebabCase(campaignName)}-influencers-${moment().utc().format()}.csv`;

  render() {
    const {
      myUserRole,
      campaign,
      error,
      loading,
      userInfo,
      campaignLoading,
      automationScanLoading,
      dyzioStorage,
    } = this.props;

    const {
      showUploadModal,
      isImporting,
    } = this.state;

    const ADDED_EMPTY_TEXT = 'No influencers added to this campaign yet. Use the pink add influencer button above to add one!';
    const INVITED_EMPTY_TEXT = 'No pending invitations.';
    const JOINED_EMPTY_TEXT = 'No influencers have joined this campaign yet.';
    const JOINED_WITH_AUTHORISED = 'No influencers are currently in the joined (but not authorised) status.';
    const AUTHORISED_EMPTY_TEXT = 'No influencers have authorised yet.';

    const LAUNCH = '4a6b0ee0-6c1a-423b-984f-49a7cb849d1e';
    const ELEVEN_MEADOW = '2434ffc0-b36a-4b07-84ac-7ec04069c4c9';
    const CORQ_AGENCY = 'ab31b8b8-6549-472f-87e1-b4732cfa9faf';
    const DYZIO_ORG_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';

    const ALLOWED_ORGS = [
      LAUNCH,
      ELEVEN_MEADOW,
      CORQ_AGENCY,
      DYZIO_ORG_ID,
    ];

    const isLaunch = _.includes(ALLOWED_ORGS, userInfo.organisationId);
    const MAX_INSTA_SCAN_FAILS = 3;

    const { filterTerm, filterType, showUploadStatusModal } = this.state;

    const { isUserSuperAdmin } = userInfo;
    const { host } = window.location;

    const isCorq = _.includes(RESTRICTED_CORQ_DOMAINS, host);
    const isAbbottLyon = _.includes('collaborators.abbottlyon.com', host);

    const campaignName = campaign.get('name');
    const campaignId = campaign.get('id');
    const isACR = campaign.get('campaignType') === 'ACR';

    const campaignOwner = campaign.get('createdBy');
    const campaignWorkflow = campaign.get('workflow');
    const isInfluencer = userInfo.role === 'INFLUENCER';
    const isUserTeamMember = isUserSuperAdmin || !isInfluencer;

    const campaignJSON = campaign.toJSON();
    const { discussions } = campaignJSON;

    const sortedDiscussions = _.sortBy(discussions, 'lastScannedDate');
    const isLoading = loading;

    const noDiscussions = _.size(discussions) === 0;

    const shouldRenderAddMoreButton = !isCorq && !isACR && isUserTeamMember;
    const shouldShowModal = this.shouldShowModal();

    let filteredDiscussions = _.filter(sortedDiscussions, discussion => {
      const influencer = discussion.influencer || getInfluencerFromOrganisations(discussion.organisations);
      return this.isSearchMatch({ discussion, influencer, searchTerm: filterTerm });
    });

    const x = _.groupBy(discussions, 'name');

    const y = _.map(x, (occurences, name) => ({
      name,
      count: occurences.length,
    }));

    const duplicates = _.filter(y, x1 => x1.count > 1);
    console.log({ duplicates });

    const igHandles = sortedDiscussions.map(discussion => {
      const influencer = _.get(discussion, 'influencer') || getInfluencerFromOrganisations(_.get(discussion, 'organisations'));
      return _.get(influencer, 'instagram');
    }).filter(Boolean);

    const igCounts = _.map(discussions, d => _.get(d, 'influencer.instagramCount', 0));
    const meanInstagram = Math.round(_.mean(igCounts));
    const totalInstagram = _.sum(igCounts);
    console.log({ meanInstagram, totalInstagram });

    const ttCounts = _.map(discussions, d => _.get(d, 'influencer.tiktokCount', 0));
    const meanTikTok = Math.round(_.mean(ttCounts));
    const totalTikTok = _.sum(ttCounts);
    console.log({ meanTikTok, totalTikTok });

    const discountSent = _.filter(sortedDiscussions, 'internalDiscountCode');
    const uploadContent = _.filter(sortedDiscussions, sd =>
      sd.workflowStatus.match(/PRODUCT_ORDERED/) || sd.workflowStatus.match(/UPLOAD_CONTENT/));

    const productOrdered = _.filter(sortedDiscussions, 'productOrderedDate');

    const totalProductOrdered = productOrdered.length;
    const hasPosted = _.filter(sortedDiscussions, 'hasPosted');

    if (filterType) {
      switch (filterType) {
      case FILTER_TYPES.posted:
        filteredDiscussions = _.filter(sortedDiscussions, 'hasPosted');
        break;
      case FILTER_TYPES.not_posted:
        filteredDiscussions = _.reject(sortedDiscussions, 'hasPosted');
        break;
      case FILTER_TYPES.errors:
        filteredDiscussions = _.filter(sortedDiscussions, d => d.instagramScanFailures > MAX_INSTA_SCAN_FAILS);
        break;
      default:
        break;
      }
    }

    const reviewMode = this.props.location.query.rm
      ? this.props.location.query.rm === 'true' : false;

    const groupedInfluencers = _.groupBy(filteredDiscussions, discussion => {
      const invitationStatus = this.getInvitationStatus({ discussion });
      const influencer = discussion.influencer || getInfluencerFromOrganisations(discussion.organisations);
      const authFields = ['instagramStatus', 'facebookStatus', 'youtubeStatus', 'twitterStatus'];
      const isAuthorised = _.some(authFields, field => _.get(influencer, field) === 'AUTHORIZED');
      return isAuthorised ? 'AUTHORIZED' : invitationStatus;
    });

    const addedExists = groupedInfluencers.DEFERRED && groupedInfluencers.DEFERRED.length > 0;
    const addedLength = groupedInfluencers.DEFERRED ? groupedInfluencers.DEFERRED.length : 0;

    const sentExists = groupedInfluencers.SENT && groupedInfluencers.SENT.length > 0;
    const sentLength = groupedInfluencers.SENT ? groupedInfluencers.SENT.length : 0;

    const joinedExists = groupedInfluencers.ACCEPTED && groupedInfluencers.ACCEPTED.length > 0;
    const joinedLength = groupedInfluencers.ACCEPTED ? groupedInfluencers.ACCEPTED.length : 0;

    const authorisedExists = groupedInfluencers.AUTHORIZED && groupedInfluencers.AUTHORIZED.length > 0;
    const authorisedLength = groupedInfluencers.AUTHORIZED ? groupedInfluencers.AUTHORIZED.length : 0;

    const creationStatus = campaign.get('creationStatus');

    const reviewList = _.reject(sortedDiscussions, 'isScanningCompleted');

    const groups = [
      {
        title: `1. Added [${addedLength}]`,
        description: 'Click on the influencer to invite them to your campaign.',
        emptyText: ADDED_EMPTY_TEXT,
        discussions: groupedInfluencers.DEFERRED,
        shouldDisplay: (addedExists) || (!(sentExists || joinedExists || authorisedExists)),
      },
      {
        title: `2. Invited [${sentLength}]`,
        description: 'These influencers have been invited to your campaign.',
        emptyText: INVITED_EMPTY_TEXT,
        discussions: groupedInfluencers.SENT,
        shouldDisplay: (sentExists || addedExists) || (!(joinedExists || authorisedExists)),
      },
      {
        title: `3. Joined [${joinedLength}]`,
        description: 'These influencers have joined your campaign but not auth\'d yet.',
        emptyText: authorisedExists ? JOINED_WITH_AUTHORISED : JOINED_EMPTY_TEXT,
        discussions: groupedInfluencers.ACCEPTED,
        shouldDisplay: (joinedExists || sentExists || addedExists) || (!(authorisedExists)),
      },
      {
        title: `4. Authorised [${authorisedLength}]`,
        description: 'These influencers have authorised the system to collect their data.',
        emptyText: AUTHORISED_EMPTY_TEXT,
        discussions: groupedInfluencers.AUTHORIZED,
        shouldDisplay: true, // (joinedExists || sentExists || addedExists || authorisedExists),
      },
    ];
    const csvData = this.buildCSVData(sortedDiscussions);
    const csvFileName = this.getCSVFileName(campaignName);
    const exportHeaders = [
      { label: 'createdDate', key: 'createdDate' },
      { label: 'name', key: 'name' },
      { label: 'internalDiscountCode', key: 'internalDiscountCode' },
      { label: 'discountCode', key: 'discountCode' },
      { label: 'bioLinkUrl', key: 'bioLinkUrl' },
      { label: 'shortDiscountLink', key: 'shortDiscountLink' },
      { label: 'workflowStatus', key: 'workflowStatus' },
      { label: 'instagram', key: 'instagram' },
      { label: 'instagramCount', key: 'instagramCount' },
      { label: 'tiktok', key: 'tiktok' },
      { label: 'tiktokCount', key: 'tiktokCount' },
      { label: 'email', key: 'email' },
      { label: 'instagramId', key: 'instagramId' },
      { label: 'tiktokId', key: 'tiktokId' },
      { label: 'usageRightsGranted', key: 'usageRightsGranted' },
      { label: 'hasPosted', key: 'hasPosted' },
    ];
    return (
      <div>
        {showUploadModal && <CsvUploadModal
          onClose={this.toggleUploadModal}
          userEmail={userInfo.email}
          userInfo={userInfo}
          campaignId={campaignId}
          isSubmitting={isImporting}
          currentInfluencerCount={discussions.length}
        />}

        {
          showUploadStatusModal && <CsvUploadStatusModal
            onClose={this.toggleUploadStatusModal}
            campaignId={campaignId}
            igHandles={igHandles}
          />
        }

        {
          !isLoading && error &&
          <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
            <div className="hero left">
              <Message color="red">
                <p>
                  There was a problem loading the campaign: {error}.
                  Please check you are connected to the internet and try again.
                </p>
              </Message>
            </div>
          </div>
        }
        {
          !isUserTeamMember && noDiscussions &&
          <div style={{ width: 1000, margin: '50px auto' }}>
            <Message
              icon="ban"
              error
              header="Sorry... You do not have access to this campaign"
              content={`Ask the campaign owner, ${campaignOwner}, to invite you.`}
            />
          </div>
        }

        { shouldShowModal &&
          <NewInfluencerTabModal onClose={this.dismissModal} onDontShowAgain={this.dontShowAgain} />
        }

        {
          isUserTeamMember && !isACR &&
            <div style={{ margin: '0px 30px' }}>

              <CampaignLiveStatus campaign={campaignJSON} />

              <Table fluid basic="very">
                <Table.Row>
                  <Table.Cell width={shouldRenderAddMoreButton ? 10 : 16}>
                    <Input
                      icon="search"
                      size="large"
                      placeholder="Search influencers..."
                      onChange={this.onFilterDiscussionListByTermChanged}
                      fluid
                    />
                  </Table.Cell>
                  {
                    shouldRenderAddMoreButton &&
                    <Table.Cell width={isLaunch ? 6 : 3}>
                      <div style={buttonsStyles.container}>
                        <Button
                          icon
                          inverted
                          fluid={!isLaunch}
                          labelPosition="left"
                          color="pink"
                          onClick={() => this.context.router.push(`/campaign/${campaignId}/invite`)}
                        >
                          <Icon name="plus" />
                        Add Influencer
                        </Button>
                        {
                          isLaunch &&
                          <div>
                            <Button
                              icon
                              inverted
                              labelPosition="left"
                              color="pink"
                              onClick={this.toggleUploadModal}
                            >
                              <Icon name="upload" />Upload CSV
                            </Button>
                            <Button
                              icon
                              inverted
                              disabled={_.isEmpty(igHandles)}
                              labelPosition="left"
                              color="pink"
                              onClick={this.toggleUploadStatusModal}
                            >
                              <Icon name="file excel" />Status
                            </Button>
                          </div>
                        }
                      </div>

                    </Table.Cell>
                  }
                </Table.Row>
              </Table>

            </div>
        }
        {
          !isLoading && campaign &&
          <div style={listStyle}>
            {
              creationStatus === 'CREATING' &&
              <Message color="orange" size="large" icon>
                <Icon name="circle notched" loading />
                <h4>Your campaign is currently being created!</h4>
                <p>&nbsp;&nbsp;This message will disappear when it has completed. Refresh your page to update.</p>
              </Message>
            }
            <Divider />

            <table width="100%">
              <tr>
                <td>

                  <Button
                    toggle
                    active={filterType === FILTER_TYPES.posted}
                    onClick={this.onFilterTypeChanged}
                    value={FILTER_TYPES.posted}
                    icon labelPosition="left" inverted color="blue"
                  >
                    <Icon name="check" color="green" />
                  Posted
                  </Button>

                  <Button
                    toggle
                    active={filterType === FILTER_TYPES.not_posted}
                    onClick={this.onFilterTypeChanged}
                    value={FILTER_TYPES.not_posted}
                    icon labelPosition="left" inverted color="blue"
                  >
                    <Icon name="close" color="orange" />
                  NOT Posted
                  </Button>

                  <Button
                    toggle
                    active={filterType === FILTER_TYPES.errors}
                    onClick={this.onFilterTypeChanged}
                    value={FILTER_TYPES.errors}
                    icon labelPosition="left" inverted color="blue"
                  >
                    <Icon name="exclamation circle" color="red" />
                  Errors
                  </Button>

                  <Label>Use these buttons to filter the influencers. Click again to remove filter.</Label>
                </td>
                <td width="200" style={{ textAlign: 'right' }}>

                  <CSVLink
                    filename={csvFileName}
                    headers={exportHeaders}
                    data={csvData}
                  >
                    <Icon name="cloud download" color="green" />
                export<br />influencer list
                  </CSVLink>
                </td>
              </tr>
            </table>


            <p />
            {
              isAbbottLyon &&
              <div>
                <Card>
                  <Card.Content>
                    <table width="100%">
                      <tr>
                        <td>average instagram followers:</td>
                        <td>{numeral(meanInstagram).format('0,0')}</td>
                      </tr>
                      <tr>
                        <td>total instagram followers:</td>
                        <td>{numeral(totalInstagram).format('0,0')}</td>
                      </tr>
                      <tr>
                        <td>average tiktok followers:</td>
                        <td>{numeral(meanTikTok).format('0,0')}</td>
                      </tr>
                      <tr>
                        <td>total tiktok followers:</td>
                        <td>{numeral(totalTikTok).format('0,0')}</td>
                      </tr>
                    </table>
                  </Card.Content>
                </Card>
              </div>
            }

            <Divider />

            { campaignWorkflow &&
              <div>
                <Label basic>DISCOUNT SENT {discountSent.length}</Label>
                <Icon name="arrow circle right outline" size="large" />
                <Label basic color="green">PRODUCT ORDERED - {totalProductOrdered}</Label>
                <Icon name="arrow circle right outline" size="large" />
                <Label basic color="blue">WAITING FOR CONTENT - {uploadContent.length}</Label>
                <Icon name="arrow circle right outline" size="large" />
                <Label basic color="pink">CONTENT FOUND - {hasPosted.length}</Label>
                <Divider />
              </div>
            }

            {
              reviewMode &&
              <div>
                <table width="100%">
                  <tr>
                    <td width="90%">
                      <Message
                        color="teal"
                        icon="warning"
                        header="REVIEW MODE"
                        content="The list is only displaying creators who have not been rolled forward"
                      />

                    </td>
                    <td width="10%" style={{ textAlign: 'center' }}>
                      <p style={{ fontSize: '80%' }}>remaining</p>
                      <Label circular basic color="teal" size="massive">
                        { reviewList.length}
                      </Label>
                    </td>
                  </tr>
                </table>
              &nbsp;
              </div>
            }

            {
              !_.isEmpty(duplicates) &&
                <Segment>
                  { _.map(duplicates, d => (
                    <Message negative icon>
                      <Icon name="clone outline" />
                      <MessageContent>
                        <MessageHeader>Duplicate collaborations found</MessageHeader>
                        There are {d.count} collaborations named {d.name}. Please delete the duplicate(s).
                      </MessageContent>
                    </Message>
                  ))}
                </Segment>
            }
            {
              _.map(groups, ({ title, description, emptyText, discussions: disc, shouldDisplay }) => {
                if (shouldDisplay) {
                  return (
                    <InfluencerGroup
                      title={title}
                      campaign={campaign}
                      description={description}
                      emptyText={emptyText}
                      discussions={disc}
                      getInvitationStatus={this.getInvitationStatus}
                      isSearchMatch={this.isSearchMatch}
                      reviewMode={reviewMode}
                    />
                  );
                }
                return (
                  null
                );
              })
            }
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  discussions: state.discussionList.get('discussions'),
  myUserRole: state.campaign.get('myUserRole'),
  error: state.discussionList.get('error'),
  loading: state.discussionList.get('loading'),
  reloadDiscussions: state.discussionList.get('reloadDiscussions'),
  campaign: state.campaign.get('campaign'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadingDiscussions: campaignId => dispatch(loadingDiscussions(campaignId)),
    onReloadDiscussions: data => dispatch(reloadDiscussions(data)),
  };
}

export default compose(
  hasUserInfo,
  hasRESTClient,
  hasLocalStorageClient,
  connect(mapStateToProps, mapDispatchToProps),
)(DiscussionList);



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-list2/index.js
 **/